"use client"

import { useRequireAuth } from "@/hooks/useAuth"
import Navbar from "./navbar"
import Footer from "./footer"
import ChatInterface from "./chat/ChatInterface"
import { Loader2 } from "lucide-react"
import { DayPlanAttentionProvider } from "@/components/day-plan/DayPlanAttentionProvider"

interface ProtectedLayoutProps {
  children: React.ReactNode
  fullWidth?: boolean
  requiredRole?: string
}

export default function ProtectedLayout({ children, fullWidth, requiredRole }: ProtectedLayoutProps) {
  const { data: session, status } = useRequireAuth()
  const isLoading = status === "loading"

  if (status === "unauthenticated") {
    return null
  }

  if (isLoading) {
    return (
      <div className="flex h-screen w-full items-center justify-center bg-gray-50 dark:bg-zinc-950 transition-colors">
        <div className="flex flex-col items-center gap-2">
          <Loader2 className="h-10 w-10 animate-spin text-blue-600" />
        </div>
      </div>
    )
  }

  if (requiredRole && session?.user?.role !== requiredRole) {
    return (
      <div className="flex h-screen w-full items-center justify-center bg-gray-50 dark:bg-zinc-950 transition-colors">
        <div className="text-center p-6 bg-white dark:bg-zinc-900 rounded-xl border border-gray-200 dark:border-zinc-800 shadow-sm max-w-md">
          <h1 className="text-2xl font-bold text-red-500 mb-2">Brak dostępu</h1>
          <p className="text-muted-foreground text-sm">Nie masz uprawnień administratora do wyświetlenia tej strony.</p>
        </div>
      </div>
    )
  }

  return (
    <DayPlanAttentionProvider>
      <div className="min-h-screen bg-gray-50 dark:bg-zinc-950 flex flex-col transition-colors">
        <Navbar />

        {/* ZMIANA: lg:pl-72 zamiast lg:pl-64 (dostosowanie do szerokości nowego sidebara)
          ZMIANA: pt-16 zamiast pt-8 (dostosowanie do wysokości top baru h-16)
        */}
        <main className="flex-1 pt-4 lg:pl-72 transition-all duration-300">
          <div className="w-full px-4 py-8 sm:px-6 lg:px-10">
            <div className="animate-in fade-in duration-500 slide-in-from-bottom-2">
              {children}
            </div>
          </div>
        </main>

        <Footer />
        <ChatInterface />
      </div>
    </DayPlanAttentionProvider>
  )
}